import React from 'react';
import P from '@deliveroo/consumer-component-library/components/P';
import i18n from '../../utils/i18n';

import styles from './styles.scss';

/**
 * An animation element to indicate that the page is constantly pinging
 * and will refresh dynamically.
 * Currently used on the Order Status page to show that the status is pinging.
 */
const LiveOrderIndicator = () => (
  <div className={styles['live-order-indicator']}>
    <div className={styles.circle} />
    <div className={styles.text}>
      <P size="small" isBold color="grey">
        {i18n.gettext('LIVE')}
      </P>
    </div>
  </div>
);

export default LiveOrderIndicator;
